import { atom } from "recoil";

const dropdownStore = atom<boolean>({
	key: "dropdownStore",
	default: false,
});

export default dropdownStore;
